/**
 * Multi-Select Question Component
 */

import React from 'react';
import { QuestionWithOptions } from '../../types/models';
import { MediaImage } from './MediaImage';

interface MultiSelectQuestionProps {
  question: QuestionWithOptions;
  selectedOptionIds: string[];
  onChange: (selectedOptionIds: string[]) => void;
  showFeedback?: boolean;
  isCorrect?: boolean;
  explanation?: string;
}

export const MultiSelectQuestion: React.FC<MultiSelectQuestionProps> = ({
  question,
  selectedOptionIds,
  onChange,
  showFeedback = false,
  isCorrect,
  explanation,
}) => {
  const addOption = (optionId: string) => {
    onChange([...selectedOptionIds, optionId]);
  };

  const removeOption = (optionId: string) => {
    onChange(selectedOptionIds.filter((id) => id !== optionId));
  };

  return (
    <div className="question multi-select">
      <h3>{question.prompt_text}</h3>
      {question.prompt_media_url && (
        <MediaImage
          src={question.prompt_media_url}
          alt="Question media"
          width={question.prompt_media_width}
          height={question.prompt_media_height}
        />
      )}
      <div className="options">
        {question.answer_options.map((option) => {
          const isSelected = selectedOptionIds.includes(option.id);
          const isCorrectOption = option.is_correct;
          let optionClass = 'option';
          if (showFeedback) {
            if (isCorrectOption) optionClass += ' correct';
            if (isSelected && !isCorrectOption) optionClass += ' incorrect';
            if (!isSelected && isCorrectOption) optionClass += ' missed';
          }

          return (
            <label key={option.id} className={optionClass}>
              <input
                type="checkbox"
                checked={isSelected}
                onChange={(e) =>
                  e.target.checked
                    ? addOption(option.id)
                    : removeOption(option.id)
                }
                disabled={showFeedback}
              />
              <span>{option.option_text}</span>
              {option.option_media_url && (
                <MediaImage
                  src={option.option_media_url}
                  alt="Option media"
                  width={option.option_media_width}
                  height={option.option_media_height}
                />
              )}
            </label>
          );
        })}
      </div>
      {showFeedback && explanation && (
        <div className="explanation">{explanation}</div>
      )}
    </div>
  );
};
